export namespace NMaterialsCalcConfig {
    export enum EFieldType {
        input,
        selector,
        image
    }

    export interface IResults {
        materialsNote: string;
        materialsValue: number | string;
        note?: string;
        area: string;
        areaUnit: string;
        additionalInfo?: {
            value: string;
            note: string;
        }[];
    }

    export const calculators: ICalculators = {
        brick: {
            id: 'brick',
            title: 'Brick/Block Calculator',
            fields: [
                {
                    id: 'brickOrBlock',
                    title: 'Please select either bricks or blocks',
                    type: EFieldType.image,
                    required: true,
                    imageOptions: [
                        {
                            group: undefined,
                            options: [
                                {
                                    id: 'brick',
                                    label: 'Brick',
                                    additionalInfo: 'Standard house brick (215 l x 65 h mm)',
                                    imageCmsName: 'brickImage'
                                },
                                {
                                    id: 'block',
                                    label: 'Block',
                                    additionalInfo: 'Block (440 l x 215 h x 100 w mm)',
                                    imageCmsName: 'blockImage'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 'height',
                    title: 'Enter your width and height',
                    type: EFieldType.input,
                    label: 'Wall Height (m)',
                    required: true
                },
                {
                    id: 'width',
                    type: EFieldType.input,
                    label: 'Wall Width (m)',
                    required: true
                }
            ]
        },
        concrete: {
            id: 'concrete',
            title: 'Concrete Calculator',
            fields: [
                {
                    id: 'width',
                    title: 'Enter footings width, length and depth',
                    type: EFieldType.input,
                    label: 'Footings Width (cm)',
                    required: true
                },
                {
                    id: 'length',
                    type: EFieldType.input,
                    label: 'Footings Length (cm)',
                    required: true
                },
                {
                    id: 'depth',
                    type: EFieldType.input,
                    label: 'Footings Depth (cm)',
                    required: true
                }
            ]
        },
        decking: {
            id: 'decking',
            title: 'Decking Calculator',
            fields: [
                {
                    id: 'width',
                    title: 'Enter decking width, length and board width',
                    type: EFieldType.input,
                    label: 'Decking Width (m)',
                    required: true
                },
                {
                    id: 'length',
                    type: EFieldType.input,
                    label: 'Decking Length (m)',
                    required: true
                },
                {
                    id: 'boardWidth',
                    type: EFieldType.selector,
                    label: 'Board Width (mm)',
                    options: [
                        {
                            id: '125',
                            label: '125 mm'
                        },
                        {
                            id: '150',
                            label: '150 mm'
                        }
                    ],
                    required: true
                }
            ]
        },
        patio: {
            id: 'patio',
            title: 'Patio Mortar Calculator',
            fields: [
                {
                    id: 'width',
                    title: 'Enter the patio width and height',
                    type: EFieldType.input,
                    label: 'Paving Width (m)',
                    required: true
                },
                {
                    id: 'length',
                    type: EFieldType.input,
                    label: 'Paving Length (m)',
                    required: true
                }
            ]
        },
        paving: {
            id: 'paving',
            title: 'Paving Calculator',
            fields: [
                {
                    id: 'brand',
                    title: 'Please select a manufacturer',
                    type: EFieldType.image,
                    required: true,
                    imageOptions: [
                        {
                            group: undefined,
                            options: [
                                {
                                    id: 'brand',
                                    label: 'Brand',
                                    imageCmsName: 'pavingBrandImage'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 'pattern',
                    title: 'Please select a pattern',
                    type: EFieldType.image,
                    imageOptions: [
                        {
                            group: 'Bronte',
                            options: [
                                {
                                    id: 'brontePattern1',
                                    label: 'Pattern 1',
                                    additionalInfo: '300x300, 450x450, 600x300, 600x450, 600x600',
                                    imageCmsName: 'patternImage1',
                                    multiplier: 2.3,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 450x450',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x450',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                },
                                {
                                    id: 'brontePattern2',
                                    label: 'Pattern 2',
                                    additionalInfo: '300x300, 450x450, 600x300, 600x600',
                                    imageCmsName: 'patternImage2',
                                    multiplier: 1.79,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 450x450',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                },
                                {
                                    id: 'brontePattern3',
                                    label: 'Pattern 3',
                                    additionalInfo: '300x300, 450x450, 600x300, 600x450, 600x600',
                                    imageCmsName: 'patternImage3',
                                    multiplier: 5.49,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 5
                                        },
                                        {
                                            text: 'x Size 450x450',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 5
                                        },
                                        {
                                            text: 'x Size 600x450',
                                            value: 9
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 3
                                        }
                                    ]
                                },
                                {
                                    id: 'brontePattern4',
                                    label: 'Pattern 4',
                                    additionalInfo: '300x300, 600x300, 600x600',
                                    imageCmsName: 'patternImage4',
                                    multiplier: 1.31,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            group: 'Quordon',
                            options: [
                                {
                                    id: 'quordonPattern5',
                                    label: 'Pattern 5',
                                    additionalInfo: '300x300, 450x450, 600x300, 600x600',
                                    imageCmsName: 'patternImage5',
                                    multiplier: 1.74,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 450x450',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                },
                                {
                                    id: 'quordonPattern6',
                                    label: 'Pattern 6',
                                    additionalInfo: '450x450, 150x150',
                                    imageCmsName: 'patternImage6',
                                    multiplier: 0.83,
                                    slabs: [
                                        {
                                            text: 'x Size 450x450',
                                            value: 1
                                        },
                                        {
                                            text: 'x Size 150x150',
                                            value: 12
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 1
                                        }
                                    ]
                                },
                                {
                                    id: 'quordonPattern7',
                                    label: 'Pattern 7',
                                    additionalInfo: '300x300, 450x450, 600x300, 600x600',
                                    imageCmsName: 'patternImage7',
                                    multiplier: 1.79,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 450x450',
                                            value: 4
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 1
                                        }
                                    ]
                                },
                                {
                                    id: 'quordonPattern8',
                                    label: 'Pattern 8',
                                    additionalInfo: '300x300, 600x300, 600x600',
                                    imageCmsName: 'patternImage8',
                                    multiplier: 1.31,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                },
                                {
                                    id: 'quordonPattern9',
                                    label: 'Pattern 9',
                                    additionalInfo: '300x300, 600x600',
                                    imageCmsName: 'patternImage9',
                                    multiplier: 0.94,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                },
                                {
                                    id: 'quordonPattern10',
                                    label: 'Pattern 10',
                                    additionalInfo: '300x300, 150x150, 600x600',
                                    imageCmsName: 'patternImage10',
                                    multiplier: 1.44,
                                    slabs: [
                                        {
                                            text: 'x Size 300x300',
                                            value: 2
                                        },
                                        {
                                            text: 'x Size 150x150',
                                            value: 24
                                        },
                                        {
                                            text: 'x Size 600x600',
                                            value: 2
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            group: 'Alpha, Beta & Lugano',
                            options: [
                                {
                                    id: 'aplhaPattern11',
                                    label: 'Pattern 11',
                                    additionalInfo: 'Small, Medium, Large',
                                    imageCmsName: 'patternImage11',
                                    multiplier: 'dyn',
                                    slabs: [
                                        {
                                            text: 'x Size Small',
                                            value: 68,
                                            additionalValue: 16
                                        },
                                        {
                                            text: 'x Size Medium',
                                            value: 51,
                                            additionalValue: 16
                                        },
                                        {
                                            text: 'x Size Large',
                                            value: 34,
                                            additionalValue: 16
                                        }
                                    ]
                                },
                                {
                                    id: 'aplhaPattern12',
                                    label: 'Pattern 12',
                                    additionalInfo: 'Small, Medium, Large',
                                    imageCmsName: 'patternImage12',
                                    multiplier: 'dyn',
                                    slabs: [
                                        {
                                            text: 'x Size Small',
                                            value: 68,
                                            additionalValue: 16
                                        },
                                        {
                                            text: 'x Size Medium',
                                            value: 51,
                                            additionalValue: 16
                                        },
                                        {
                                            text: 'x Size Large',
                                            value: 34,
                                            additionalValue: 16
                                        }
                                    ]
                                },
                                {
                                    id: 'aplhaPattern13',
                                    label: 'Pattern 13',
                                    additionalInfo: 'Small, Medium, Large, Jumper',
                                    imageCmsName: 'patternImage13',
                                    multiplier: 'dyn',
                                    slabs: [
                                        {
                                            text: 'x Size Small',
                                            value: 68,
                                            additionalValue: 15
                                        },
                                        {
                                            text: 'x Size Medium',
                                            value: 51,
                                            additionalValue: 15
                                        },
                                        {
                                            text: 'x Size Large',
                                            value: 34,
                                            additionalValue: 8
                                        },
                                        {
                                            text: 'x Size Jumper',
                                            value: 17,
                                            additionalValue: 5
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    required: true
                },
                {
                    id: 'area',
                    type: EFieldType.input,
                    title: 'Enter your area',
                    label: 'Area (m²)',
                    required: true
                }
            ],
            doc: true
        }
    };

    export interface ISlab {
        text: string;
        value: number;
        additionalValue?: number;
    }

    export interface ICalculators {
        [key: string]: ICalculator;
    }

    export interface ICalculator {
        id: string;
        title: string;
        fields: IField[];
        doc?: boolean;
    }

    export interface IField {
        id: string;
        title?: string;
        label?: string;
        type: EFieldType;
        options?: IOption[];
        imageOptions?: IImageOption[];
        required?: boolean;
    }

    export interface IOption {
        id: string;
        label: string;
        imageCmsName?: string;
        additionalInfo?: string;
        multiplier?: number | string;
        slabs?: ISlab[];
    }

    export interface IImageOption {
        group?: string;
        options: IOption[];
    }
}
